"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownItem = undefined;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownItem = exports.DropdownItem = function DropdownItem(id, filterId, text, messageDescriptor) {
  (0, _classCallCheck3.default)(this, DropdownItem);

  this.id = id;
  this.filterId = filterId;
  this.text = text;
  this.messageDescriptor = messageDescriptor;
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dropdown/DropdownItem.js
// module id = 812
// module chunks = 0